import types from './types';

export default {
    [types.ancientOffer](state, val) {
        state.testResult = val;
    }
};
